import _get from 'lodash/get';

export const ITEMS_IN_WIDGET = 6;
export const LIMIT = 30;

export const SORT_BY = {
  CREATED_AT: 'createdAt',
}

export const ORDER = {
  ASC: '',
  DESC: '-',
};

export const PAYOUTS_TYPE = {
  POOL: 'pool',
  OS: 'os',
};

export const STATUSES = {
  FAILED_UNRESOLVED: 'failed_unresolved',
  FAILED_RESOLVED: 'failed_resolved',
  WAIT_APPROVE: 'wait_approve',
  PENDING: 'pending',
  REJECTED: 'rejected',
  WAIT_IN_QUEUE: 'wait_in_queue',
  WAIT_GAS_PRICE: 'wait_gas_price',
  SUCCESS: 'succeed',
  UNKNOWN: 'unknown',
}

export const REJECTED_STATUSES = [
  STATUSES.REJECTED, 
  STATUSES.FAILED_RESOLVED, 
  STATUSES.FAILED_UNRESOLVED,
];

export const STATUSES_MESSAGES = {
  [STATUSES.FAILED_UNRESOLVED]: 'status.failed_unresolved',
  [STATUSES.FAILED_RESOLVED]: 'status.failed_resolved',
  [STATUSES.WAIT_APPROVE]: 'status.wait_approve',
  [STATUSES.PENDING]: 'status.pending',
  [STATUSES.REJECTED]: 'status.rejected',
  [STATUSES.WAIT_IN_QUEUE]: 'status.wait_in_queue',
  [STATUSES.WAIT_GAS_PRICE]: 'status.wait_gas_price',
  [STATUSES.SUCCESS]: 'status.succeed',
  [STATUSES.UNKNOWN]: 'status.unknown',
}

export const getStatusMessage = (status: string) => {
  return _get(STATUSES_MESSAGES, status, STATUSES_MESSAGES.TX_STATUS_NEW);
}

export const getStatusIconVariant = (status: string) : any => {
  let variant = 'warning';
  switch (status) {
    case STATUSES.UNKNOWN:
    case STATUSES.WAIT_IN_QUEUE:
    case STATUSES.PENDING:
    case STATUSES.WAIT_GAS_PRICE:
    case STATUSES.WAIT_APPROVE:
      variant = 'warning';
      break;
    case STATUSES.SUCCESS:
      variant = 'success';
      break;
    case STATUSES.REJECTED:
    case STATUSES.FAILED_UNRESOLVED:
    case STATUSES.FAILED_RESOLVED:
      variant = 'danger';
      break;
  }
  return variant;
}